<template>
  <v-snackbar v-model="snackbar.show" :timeout="snackbar.timeout" :color="snackbar.color">
    {{ snackbar.text }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="snackbar.show = false"> Schließen </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default { props: ["snackbar"] };
</script>

<style></style>
